/**
 * @class
 * @description Wrapper class that injects our modified hlsjs loader in a hlsjs player instance.
 * @exports HlsJs
 */
export default class HlsJs {
    /**
     * Constructs Hls adapter.
     * @param {Object} player Hls player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        player.config.loader = HlsJs._adapters.getLoaders().LoaderHlsjs;
    }
}
